<script setup>
import { computed } from 'vue'
import { useSynthesize } from '../video/create/text-to-speech/use-text-to-speech.js'
import { useProvidePreviewVoice } from './preview-voice/use-preview-voice.js'
import constants from '@/generated/constants.js'

const props = defineProps({
  message: {
    type: String,
    required: true
  }
})

const { isLoading, synthesize } = useSynthesize()
const { audioContent, audioRef, playing } = useProvidePreviewVoice()
const tooltip = computed(() => playing.value ? 'Click to pause the audio' : 'Click to play the audio')

const toggleAudio = async () => {
  try {
    audioRef.value?.pause()

    if (playing.value) {
      return
    }

    if (!audioContent.value) {
      audioContent.value = await synthesize({
        input: props.message,
        voice: constants.App_Extensions_OpenAi_Enums_Voice.ALLOY
      })
    }

    await audioRef.value.play()
  } catch (err) {
    if (err.response?.status === 422) {
      await window.SwalTimer.fire({
        icon: 'error',
        title: 'Error',
        text: Object.values(err.response.data)[0][0]
      })
    }
  }
}
</script>

<template>
  <button
    class="btn btn-light btn-icon btn-xs hint--rounded hint--top-right"
    :aria-label="tooltip"
    :disabled="isLoading"
    @click="toggleAudio"
  >
    <i
      v-if="isLoading"
      class="fas fa-spinner fa-spin"
    />
    <i
      v-else-if="playing"
      class="fas fa-circle-stop"
    />
    <i
      v-else
      class="fas fa-volume"
    />
  </button>
</template>
